module.exports = __webpack_public_path__ + "static/liva-convert-detail1-353265d2def36a6d391d4d5b2996868d.png";